import { takeEvery, put, take, call } from 'redux-saga/effects'
import { push } from 'redux-first-history'
import {
  saveExpenseFailed,
  saveExpenseSuccess,
  getExpenseSuccess,
  getExpenseFailed,
  emptyExpenseRows,
  loadAllowanceCostSuccess,
  saveAllowanceSuccess,
  saveAllowanceFailed,
  // allowanceUpdateExceedLimitFailed,
  getExpenseByIdSuccess,
  getAllowanceByIdSuccess,
  expenseUpdateSuccess,
  expenseUpdateFailed,
  allowanceUpdateSuccess,
  allowanceUpdateFailed,
  // cancelExpenseUpdate,
  // cancelAllowanceUpdate,
  // changeExpensePurchaseDate,
  updateInvoiceIdToInfoSuccess,
  updateInvoiceIdToInfoExceedLimitFailed,
  updateInvoiceIdToInfoFailed,
  getExpenseStart,
  disableExpenseBackBtn,
  disableAllowanceBackBtn,
  // closeExpenseSnackBar, // (KAS-328) this function will be called in the snackbar's onClose props
  // loadInvoiceItems,
  closeLoadExpenseItems,
  updateExpenseSelectedList,
  addExpensesToInvoice,
  addAllowancesToInvoice,
  editAndGoToInvoice,
  loadAllowanceCostFailed
} from '../actions/index'
import {
  SAVE_EXPENSE,
  API_SERVER,
  GET_EXPENSE_START,
  SAVE_ALLOWANCE,
  LOAD_ALLOWANCE_COST,
  REMOVE_EXPENSE,
  REMOVE_ALLOWANCE,
  EDIT_EXPENSE,
  EDIT_ALLOWANCE,
  SAVE_EXPENSE_UPDATE,
  CANCEL_EXPENSE_UPDATE,
  SAVE_ALLOWANCE_UPDATE,
  CALCULATE_DISTANCE,
  UPDATE_INVOICEID_TO_EXPENSE,
  UPDATE_INVOICEID_TO_ALLOWANCE,
  CLEAR_ADDITIONAL_VEHICLE_INFO,
  COPY_ALLOWANCE,
  CANCEL_ALLOWANCE_UPDATE
} from '../constants/index'
import {
  apiManualRequest,
  apiManualPost,
  createUploadFileChannel
} from '../utils/request'
import store from '../store'
import { formatFiDateToISO, formatFiTimeToISO } from '../utils/DateTimeFormat'
import { calculateDistance } from '../utils/expense.utils'
import { setFieldValue, updateFormValues, resetForm } from '../form'
import { defaultValues as allowanceDefaults } from '../components/expenses/newAllowance.component'

/**
 * @author Pragya Gupta
 */

function* getExpenseStartSaga({ data }) {
  let selectedUser

  if (data == undefined) {
    selectedUser = store.getState().adminUser.selectedUser
  } else {
    selectedUser = data
  }

  try {
    const expenseUrl = `${API_SERVER}/GetExpenses`

    const uuid = store.getState().client.user.data[2]
    const userType = store.getState().client.user.data[5]

    const body = JSON.stringify({
      uuid: userType == 2 ? selectedUser.uuid : uuid
    })

    const expResult = yield call(apiManualPost, expenseUrl, body)
    const expenseResult = JSON.parse(expResult.data)

    //console.log('expenseResult:: ', expenseResult)
    const expenses = []

    for (const expense of expenseResult) {
      expenses.push(expense)
    }

    //console.log('expenses:: ', expenses)

    const allowanceUrl = `${API_SERVER}/GetAllowances`

    const allowResult = yield call(apiManualPost, allowanceUrl, body)
    const allowanceResult = JSON.parse(allowResult.data)

    //console.log('allowanceResult:: ', allowanceResult)

    const allowances = []

    for (const allowance of allowanceResult) {
      allowances.push(allowance)
    }

    //console.log('allowances:: ', allowances)
    yield put(getExpenseSuccess(expenses, allowances))

    //console.log('expenses', expenses)
    // To fix checkbox bug --> if selectedCheckboxes exist, update the expenseSelected
    let selectedExpenses
    let expenseSelected = store.getState().expense.expenseSelected
    if (expenseSelected.length > 0) {
      //console.log('expenseSelectedexist')
      selectedExpenses = expenseSelected.map((item) => item + 1)
      yield put(updateExpenseSelectedList(selectedExpenses))
    }
  } catch (e) {
    yield put(getExpenseFailed(e))
  }
}

function* saveExpenseSaga({ formValues }) {
  try {
    const url = `${API_SERVER}/AddExpenses`

    const file = formValues.inputFile[0]

    const userType = store.getState().client.user.data[5]
    const { adminUser } = store.getState()
    const { selectedUser } = adminUser
    const uuid =
      userType == 2 ? selectedUser.uuid : store.getState().client.user.data[2]

    const body = {
      place_of_purchase: formValues.place_of_purchase,
      date_of_purchase: formatFiDateToISO(formValues.date_of_purchase),
      attach_option: formValues.decisionSelect,
      expenseInputRow: !!formValues.expenseInputRow
        ? formValues.expenseInputRow.filter((el) => el)
        : []
    }

    const enable_expense_back_btn =
      store.getState().invoice.enable_expense_back_btn
    const invoiceFormValues = store.getState().invoice.invoiceFormValues
    if (invoiceFormValues !== null) {
      invoiceFormValues.addCost = true
    }
    const isEdit = store.getState().invoice.isEdit
    const invoiceEdit = isEdit ? store.getState().invoice.invoiceEdit : null

    const channel = yield call(createUploadFileChannel, url, file, body, uuid)
    while (true) {
      const { err, status, success, data } = yield take(channel)
      if (err) {
        yield put(saveExpenseFailed(status))
        yield put(emptyExpenseRows())
      }
      if (success) {
        if (
          enable_expense_back_btn &&
          formValues.decisionSelect === 'add_to_invoice'
        ) {
          yield put(disableExpenseBackBtn())
          let jsonData = JSON.parse(data)
          if (typeof jsonData === 'string') {
            //FIXME: data is coming like '"data"', should be simply "data"
            jsonData = JSON.parse(jsonData)
          }
          yield put(
            addExpensesToInvoice(
              [jsonData[0].expenseId],
              invoiceFormValues,
              invoiceEdit
            )
          )
        } else if (
          enable_expense_back_btn &&
          formValues.decisionSelect === 'add_to_payroll'
        ) {
          yield put(push('/dashboard/invoice'))
          yield put(editAndGoToInvoice(invoiceFormValues, invoiceEdit))
        } else {
          yield put(saveExpenseSuccess(success))
          yield put(
            setFieldValue('invoice', {
              field: 'addCost',
              value: false
            })
          )
        }
        yield put(getExpenseStart())
        // (KAS-328) this function will be called in the snackbar's onClose props
        // yield put(closeExpenseSnackBar())
        yield put(emptyExpenseRows())
      }
      // console.log(progress)
    }
  } catch (e) {
    yield put(saveExpenseFailed())
    // console.log(e)
  }
}

function* saveAllowanceSaga({ formValues }) {
  try {
    const url = `${API_SERVER}/AddAllowances`

    const uuid = store.getState().client.user.data[2]
    const userType = store.getState().client.user.data[5]
    const { adminUser } = store.getState()
    const { selectedUser } = adminUser
    const allowanceCost = store.getState().expense.allowanceCost

    const distance = parseFloat(
      formValues.distance.toString().replace(/,/g, '.')
    )

    const startPlace = formValues.startPlace
    const endPlace = formValues.endPlace
    const finalAllowanceRow = startPlace.concat(endPlace).filter((obj) => obj)

    const refinedForm = Object.assign(
      {},
      { ...formValues },
      {
        uuid: userType == 2 ? selectedUser.uuid : uuid,
        allowanceInputRow: finalAllowanceRow,
        start_date: formatFiDateToISO(formValues.start_date),
        end_date: formatFiDateToISO(formValues.end_date),
        start_time: formatFiTimeToISO(formValues.start_time),
        end_time: formatFiTimeToISO(formValues.end_time),
        vehicle_type_id: !!formValues.vehicle_type
          ? allowanceCost[formValues.vehicle_type]['id']
          : '1',
        additional_vehicle_cost_id: !!formValues.additional_vehicle_cost
          ? allowanceCost[formValues.additional_vehicle_cost]['id']
          : '2',
        allowancePassenger: !!formValues.allowancePassenger
          ? formValues.allowancePassenger.filter((el) => el)
          : [],
        mileage_allowance: !!formValues.mileage_allowance,
        distance: formValues.mileage_allowance ? distance : '',
        day_allowance: !!formValues.day_allowance,
        attach_option: formValues.decisionSelect
      }
    )

    delete refinedForm.invoice
    //delete refinedForm.allowanceInputRow
    // delete refinedForm.allowancePassenger

    const result = yield call(
      apiManualPost,
      url,
      JSON.stringify({ ...refinedForm })
    )

    const resultParsed = result.data ? JSON.parse(result.data) : []

    const enable_allowance_back_btn =
      store.getState().invoice.enable_allowance_back_btn
    const invoiceFormValues = store.getState().invoice.invoiceFormValues
    if (invoiceFormValues !== null) {
      invoiceFormValues.addAllowance = true
    }
    const isEdit = store.getState().invoice.isEdit
    const invoiceEdit = isEdit ? store.getState().invoice.invoiceEdit : null

    if (result.status === 400) {
      yield put(saveAllowanceFailed(result.errMessage))
    } else if (resultParsed[0].allowanceId) {
      if (
        enable_allowance_back_btn &&
        formValues.decisionSelect === 'add_to_invoice'
      ) {
        yield put(disableAllowanceBackBtn())
        yield put(
          addAllowancesToInvoice(
            [resultParsed[0].allowanceId],
            invoiceFormValues,
            invoiceEdit
          )
        )
      } else if (
        enable_allowance_back_btn &&
        formValues.decisionSelect === 'add_to_payroll'
      ) {
        yield put(push('/dashboard/invoice'))
        yield put(disableAllowanceBackBtn())
        yield put(editAndGoToInvoice(invoiceFormValues, invoiceEdit))
      } else {
        yield put(saveAllowanceSuccess(result.data))
        yield put(
          setFieldValue('invoice', {
            field: 'addAllowance',
            value: false
          })
        )
      }
      yield put(getExpenseStart())
      // (KAS-328) this function will be called in the snackbar's onClose props
      // yield put(closeExpenseSnackBar())
    }
  } catch (error) {
    yield put(saveAllowanceFailed(error))
  }
}

function* loadAllowanceCostSaga(data) {
  try {
    const url = `${API_SERVER}/GetAllowanceCostbyYear?year=${data.year}`
    const result = yield call(apiManualRequest, url)
    const allowanceCostResult = JSON.parse(result.data)
    yield put(loadAllowanceCostSuccess(allowanceCostResult))
  } catch (error) {
    yield put(loadAllowanceCostFailed(error))
  }
}

function* removeExpenseSaga({ invoice_expense_id }) {
  try {
    const url = `${API_SERVER}/DeleteExpenses`
    const body = JSON.stringify({ invoice_expense_id: invoice_expense_id })
    yield call(apiManualPost, url, body)
  } catch (e) {
    // console.warn(e)
  }
}

function* removeAllowanceSaga({ id }) {
  try {
    const url = `${API_SERVER}/DeleteAllowances`
    const body = JSON.stringify({ id: id })
    yield call(apiManualPost, url, body)
  } catch (e) {
    // console.warn(e)
  }
}

function* editExpenseSaga({ invoice_expense_id }) {
  try {
    const url = `${API_SERVER}/GetExpensesByExpenseID`
    const body = JSON.stringify({ invoice_expense_id: invoice_expense_id })
    const result = yield call(apiManualPost, url, body)
    const expenseResult = JSON.parse(result.data)

    if (expenseResult) {
      const formValues = {}
      formValues.date_of_purchase = new Date(expenseResult[0].date_of_purchase)
      formValues.place_of_purchase = expenseResult[0].place_of_purchase
      formValues.expenseInputRow = expenseResult[0].expenseInputRow
      formValues.receipt_picture = ''
      formValues.inputFile = ''
      formValues.decisionSelect = expenseResult[0].attach_option
      formValues.consent = true

      for (let i = 0; i < formValues.expenseInputRow.length; i++) {
        let sum = parseFloat(formValues.expenseInputRow[i].sum)
        let vat = parseInt(formValues.expenseInputRow[i].vat)
        let sumWithoutVat =
          !isNaN(sum) && !isNaN(vat)
            ? Math.round((sum / (1 + vat / 100)) * 100) / 100
            : null
        formValues.expenseInputRow[i].sumWithoutVat = sumWithoutVat
      }

      yield put(getExpenseByIdSuccess([{ ...expenseResult[0], ...formValues }]))
      yield put(updateFormValues('expense', formValues))
    }

    yield put(closeLoadExpenseItems())
  } catch (e) {
    // console.warn(e)
    yield put(closeLoadExpenseItems())
  }
}

function* updateInvoiceIdToExpenseSaga({ invoice_id, option, selected }) {
  try {
    const url = `${API_SERVER}/UpdateInvoiceIdToExpense`
    const uuid = store.getState().client.user.data[2]
    const selectedExpenseIds = selected

    const userType = store.getState().client.user.data[5]
    const { adminUser } = store.getState()
    const { selectedUser } = adminUser

    const body = JSON.stringify({
      invoice_expense_ids: selectedExpenseIds,
      invoice_id: invoice_id,
      attach_option: option,
      uuid: userType == 2 ? selectedUser.uuid : uuid
    })

    const result = yield call(apiManualPost, url, body)
    //console.log('Inside updateInvoiceIdToExpenseSaga:: ', result.data)

    if (result.data === 'Expenses added to payroll successfully!') {
      yield put(updateInvoiceIdToInfoSuccess())
    } else if (
      result.data === 'Added expense and allowance sum greater than invoice sum'
    ) {
      yield put(updateInvoiceIdToInfoExceedLimitFailed())
    } else {
      yield put(updateInvoiceIdToInfoFailed())
    }

    yield put(getExpenseStart())
  } catch (e) {
    updateInvoiceIdToInfoFailed(e)
  }
}

function* updateInvoiceIdToAllowanceSaga({ invoice_id, option, selected }) {
  try {
    const url = `${API_SERVER}/UpdateInvoiceIdToAllowance`
    const uuid = store.getState().client.user.data[2]
    const selectedAllowanceIds = selected

    const userType = store.getState().client.user.data[5]
    const { adminUser } = store.getState()
    const { selectedUser } = adminUser

    const body = JSON.stringify({
      invoice_allowance_ids: selectedAllowanceIds,
      invoice_id: invoice_id,
      attach_option: option,
      uuid: userType == 2 ? selectedUser.uuid : uuid
    })

    const result = yield call(apiManualPost, url, body)
    //console.log('Inside updateInvoiceIdToAllowanceSaga:: ', result.data)

    if (result.data === 'Allowance added to payroll successfully!') {
      yield put(updateInvoiceIdToInfoSuccess())
    } else if (
      result.data === 'Added expense and allowance sum greater than invoice sum'
    ) {
      yield put(updateInvoiceIdToInfoExceedLimitFailed())
    } else {
      yield put(updateInvoiceIdToInfoFailed())
    }

    yield put(getExpenseStart())
  } catch (e) {
    updateInvoiceIdToInfoFailed(e)
  }
}

function* editAllowanceSaga({ id }) {
  try {
    const url = `${API_SERVER}/GetAllowancesByAllowanceID`

    const body = JSON.stringify({ id: id })
    const result = yield call(apiManualPost, url, body)
    const allowanceResult = JSON.parse(result.data)

    if (allowanceResult) {
      yield put(getAllowanceByIdSuccess(allowanceResult))

      const formValues = {
        ...allowanceDefaults,
        ...allowanceResult[0]
      }

      const allowanceInputRow = formValues.allowanceInputRow
      const startPlace = allowanceInputRow.slice(
        0,
        allowanceInputRow.length - 1
      )
      formValues.startPlace = startPlace
      const endPlace = allowanceInputRow.slice(-1)
      formValues.endPlace = endPlace

      formValues.start_date = new Date(allowanceResult[0].start_date)
      formValues.start_time = new Date(
        `${allowanceResult[0].start_date}T${allowanceResult[0].start_time}`
      )
      formValues.end_date = new Date(allowanceResult[0].end_date)
      formValues.end_time = new Date(
        `${allowanceResult[0].end_date}T${allowanceResult[0].end_time}`
      )

      formValues.vehicle_type = allowanceResult[0].vehicle_Info[0].vehicle_type
      formValues.additional_vehicle_cost =
        allowanceResult[0].additional_vehicle_Info[0].additional_vehicle_type

      formValues.decisionSelect = allowanceResult[0].attach_option
      formValues.consent = true

      yield put(updateFormValues('allowance', formValues))
    }
  } catch (e) {
    // console.warn(e)
  }
}

function* saveExpenseUpdateSaga({ formValues }) {
  const url = `${API_SERVER}/UpdateExpenses`
  const invoice_expense_id =
    store.getState().expense.expenseEdit[0].invoice_expense_id
  const userType = store.getState().client.user.data[5]
  const { adminUser } = store.getState()
  const { selectedUser } = adminUser
  const uuid =
    userType == 2 ? selectedUser.uuid : store.getState().client.user.data[2]

  const body = {
    invoice_expense_id: invoice_expense_id,
    place_of_purchase: formValues.place_of_purchase,
    date_of_purchase: formatFiDateToISO(formValues.date_of_purchase),
    attach_option: formValues.decisionSelect,
    expenseInputRow: !!formValues.expenseInputRow
      ? formValues.expenseInputRow.filter((el) => el)
      : []
  }

  const file = formValues.inputFile[0]

  try {
    const channel = yield call(createUploadFileChannel, url, file, body, uuid)
    while (true) {
      const { err, success, data } = yield take(channel)
      if (err) {
        yield put(expenseUpdateFailed(err))
      }

      if (success) {
        if (
          JSON.parse(data) ===
          'Added expense and allowance sum greater than invoice sum'
        ) {
          yield put(updateInvoiceIdToInfoExceedLimitFailed())
        } else {
          yield put(expenseUpdateSuccess(success))
        }
      }
      // console.log(progress)
      yield put(getExpenseStart())
    }
  } catch (e) {
    expenseUpdateFailed(e)
  }
}

function* cancelExpenseUpdateSaga() {
  try {
    yield put(resetForm('expense'))
  } catch (e) {
    // console.warn(e)
  }
}

function* cancelAllowanceUpdateSaga() {
  try {
    yield put(resetForm('allowance'))
  } catch (e) {
    // console.warn(e)
  }
}

function* saveAllowanceUpdateSaga({ formValues }) {
  try {
    const url = `${API_SERVER}/UpdateAllowances`

    const uuid = store.getState().client.user.data[2]
    const userType = store.getState().client.user.data[5]
    const { adminUser } = store.getState()
    const { selectedUser } = adminUser
    const id = store.getState().expense.allowanceEdit[0].id
    const allowanceCost = store.getState().expense.allowanceCost

    const distance = formValues.distance.toString().replace(/,/g, '.')

    const startPlace = formValues.startPlace
    const endPlace = formValues.endPlace
    const finalAllowanceRow = startPlace.concat(endPlace).filter((obj) => obj)

    const refinedForm = Object.assign(
      {},
      { ...formValues },
      {
        id: id,
        uuid: userType == 2 ? selectedUser.uuid : uuid,
        allowanceInputRow: finalAllowanceRow,

        start_date: formatFiDateToISO(formValues.start_date),
        end_date: formatFiDateToISO(formValues.end_date),
        start_time: formatFiTimeToISO(formValues.start_time),
        end_time: formatFiTimeToISO(formValues.end_time),

        distance: formValues.mileage_allowance ? distance : '',
        license_plate: formValues.mileage_allowance
          ? formValues.license_plate
          : '',

        vehicle_type_id: formValues.mileage_allowance
          ? !!formValues.vehicle_type
            ? allowanceCost[formValues.vehicle_type]['id']
            : '1'
          : '1',

        additional_vehicle_cost_id: formValues.mileage_allowance
          ? !!formValues.additional_vehicle_cost
            ? allowanceCost[formValues.additional_vehicle_cost]['id']
            : '2'
          : '2',

        allowancePassenger: formValues.mileage_allowance
          ? !!formValues.allowancePassenger
            ? formValues.allowancePassenger.filter((el) => el)
            : []
          : [],

        passenger_count: formValues.mileage_allowance
          ? formValues.passenger_count
          : 0,
        sum_mileage_allowance: formValues.mileage_allowance
          ? formValues.sum_mileage_allowance
          : 0,
        forest_trail: formValues.mileage_allowance
          ? formValues.forest_trail
          : 0,
        heavy_load: formValues.mileage_allowance ? formValues.heavy_load : 0,
        working_dog: formValues.mileage_allowance ? formValues.working_dog : 0,
        mileage_allowance: !!formValues.mileage_allowance,
        day_allowance: !!formValues.day_allowance,
        meal_allowance: formValues.day_allowance
          ? formValues.meal_allowance
          : 0,
        full_time_allowance: formValues.day_allowance
          ? formValues.full_time_allowance
          : 0,
        part_time_allowance: formValues.day_allowance
          ? formValues.part_time_allowance
          : 0,
        attach_option: formValues.decisionSelect
      }
    )

    delete refinedForm.invoice
    delete refinedForm.deleted
    delete refinedForm.deleted_at
    delete refinedForm.created
    delete refinedForm.last_modified_date
    delete refinedForm.sum_full_time_allowance
    delete refinedForm.sum_meal_time_allowance
    delete refinedForm.sum_mileage_allowance
    delete refinedForm.sum_part_time_allowance
    delete refinedForm.sum_total_allowance

    const result = yield call(
      apiManualPost,
      url,
      JSON.stringify({ ...refinedForm })
    )

    if (result.status === 400) {
      yield put(allowanceUpdateFailed(result.errMessage))
    } else if (result.data === 'Allowances updated successfully!') {
      yield put(allowanceUpdateSuccess(result.data))
    } else if (
      result.data === 'Added expense and allowance sum greater than invoice sum'
    ) {
      // yield put(allowanceUpdateExceedLimitFailed(result.data))
      yield put(updateInvoiceIdToInfoExceedLimitFailed())
    } else {
      yield put(allowanceUpdateFailed(result.data))
    }
    yield put(getExpenseStart())
  } catch (e) {
    allowanceUpdateFailed(e)
  }
}

async function cal(startPlace, endPlace) {
  return await calculateDistance(startPlace, endPlace)
}

function* allowanceCalculateDistanceSaga({ formValues }) {
  try {
    const startPlace = formValues.startPlace
    const endPlace = formValues.endPlace
    const finalAllowanceRow = startPlace.concat(endPlace).filter((obj) => obj)
    const occurencesRoute = finalAllowanceRow.filter((el) => el.route).length
    const l = finalAllowanceRow.slice(0, occurencesRoute).length
    const routePoints = []
    for (let i = 0; i < l; i++) {
      routePoints.push(finalAllowanceRow[i].route)
    }

    const routePointsFinal = routePoints.filter((obj) => obj)
    const routeSize = routePointsFinal.length
    if (routeSize === 2) {
      const startPlace = routePointsFinal[0]
      const endPlace = routePointsFinal[1]
      let calcDist = yield call(cal, startPlace, endPlace)

      yield put(
        setFieldValue('allowance', [
          { field: 'mileage_allowance', value: true },
          { field: 'distance', value: calcDist.toFixed(1) }
        ])
      )
    } else if (routeSize > 2) {
      let dist = []
      for (let j = 0; j < routePointsFinal.length - 1; j++) {
        const startPlace = routePointsFinal[j]
        const endPlace = routePointsFinal[j + 1]
        let distValue = yield call(cal, startPlace, endPlace)
        dist.push(distValue)
      }

      const distSum = dist.reduce((a, b) => a + b)
      const rounded_dist = distSum.toFixed(1)

      yield put(
        setFieldValue('allowance', [
          { field: 'mileage_allowance', value: true },
          { field: 'distance', value: rounded_dist }
        ])
      )
    }
  } catch (e) {
    // console.warn(e)
  }
}

function* clearAdditionalVehicleInfoSaga() {
  try {
    yield put(
      setFieldValue('allowance', [
        {
          field: 'additional_vehicle_cost',
          value: 'default_additional_vehicle_cost'
        },
        { field: 'forest_trail', value: false },
        { field: 'heavy_load', value: false },
        { field: 'working_dog', value: false }
      ])
    )
  } catch (e) {
    // console.log(e)
  }
}

function* copyAllowanceSaga({ id }) {
  try {
    const url = `${API_SERVER}/GetAllowancesByAllowanceID`

    const body = JSON.stringify({ id: id })
    const result = yield call(apiManualPost, url, body)
    const allowanceResult = JSON.parse(result.data)

    if (allowanceResult) {
      const formValues = {
        ...allowanceDefaults,
        ...allowanceResult[0]
      }

      const allowanceInputRow = formValues.allowanceInputRow
      const startPlace = allowanceInputRow.slice(
        0,
        allowanceInputRow.length - 1
      )
      formValues.startPlace = startPlace
      const endPlace = allowanceInputRow.slice(-1)
      formValues.endPlace = endPlace

      formValues.start_date = new Date(allowanceResult[0].start_date)
      formValues.start_time = new Date(
        `${allowanceResult[0].start_date}T${allowanceResult[0].start_time}`
      )
      formValues.end_date = new Date(allowanceResult[0].end_date)
      formValues.end_time = new Date(
        `${allowanceResult[0].end_date}T${allowanceResult[0].end_time}`
      )

      formValues.vehicle_type = allowanceResult[0].vehicle_Info[0].vehicle_type
      formValues.additional_vehicle_cost =
        allowanceResult[0].additional_vehicle_Info[0].additional_vehicle_type

      formValues.decisionSelect = allowanceResult[0].attach_option
      formValues.consent = true

      yield put(updateFormValues('allowance', formValues))
    }
  } catch (e) {
    console.warn(e)
  }
}

export function* watchSaveExpenseSaga() {
  yield takeEvery(SAVE_EXPENSE, saveExpenseSaga)
}

export function* watchGetExpenseStartSaga() {
  yield takeEvery(GET_EXPENSE_START, getExpenseStartSaga)
}

export function* watchSaveAllowanceSaga() {
  yield takeEvery(SAVE_ALLOWANCE, saveAllowanceSaga)
}

export function* watchLoadAllowanceCostSaga() {
  yield takeEvery(LOAD_ALLOWANCE_COST, loadAllowanceCostSaga)
}

export function* watchRemoveExpenseSaga() {
  yield takeEvery(REMOVE_EXPENSE, removeExpenseSaga)
}

export function* watchEditExpenseSaga() {
  yield takeEvery(EDIT_EXPENSE, editExpenseSaga)
}

export function* watchRemoveAllowanceSaga() {
  yield takeEvery(REMOVE_ALLOWANCE, removeAllowanceSaga)
}

export function* watchEditAllowanceSaga() {
  yield takeEvery(EDIT_ALLOWANCE, editAllowanceSaga)
}

export function* watchSaveExpenseUpdateSaga() {
  yield takeEvery(SAVE_EXPENSE_UPDATE, saveExpenseUpdateSaga)
}

export function* watchCancelExpenseUpdateSaga() {
  yield takeEvery(CANCEL_EXPENSE_UPDATE, cancelExpenseUpdateSaga)
}

export function* watchCancelAllowanceUpdateSaga() {
  yield takeEvery(CANCEL_ALLOWANCE_UPDATE, cancelAllowanceUpdateSaga)
}

export function* watchSaveAllowanceUpdateSaga() {
  yield takeEvery(SAVE_ALLOWANCE_UPDATE, saveAllowanceUpdateSaga)
}

export function* watchAllowanceCalculateDistanceSaga() {
  yield takeEvery(CALCULATE_DISTANCE, allowanceCalculateDistanceSaga)
}

export function* watchUpdateInvoiceIdToExpenseSaga() {
  yield takeEvery(UPDATE_INVOICEID_TO_EXPENSE, updateInvoiceIdToExpenseSaga)
}

export function* watchUpdateInvoiceIdToAllowanceSaga() {
  yield takeEvery(UPDATE_INVOICEID_TO_ALLOWANCE, updateInvoiceIdToAllowanceSaga)
}

export function* watchClearAdditionalVehicleInfo() {
  yield takeEvery(CLEAR_ADDITIONAL_VEHICLE_INFO, clearAdditionalVehicleInfoSaga)
}

export function* watchCopyAllowanceSaga() {
  yield takeEvery(COPY_ALLOWANCE, copyAllowanceSaga)
}
